import { render, staticRenderFns } from "./substantiation-alert.component.vue?vue&type=template&id=f3097f86&"
import script from "./substantiation-alert.component.vue?vue&type=script&lang=ts&"
export * from "./substantiation-alert.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports